import {IWindowService  } from 'angular';

export class LocalyticsService {
    constructor(private $window: IWindowService) {
    }
    public logLocalytics(eventName: string, parameters: Object) {
        this.$window.logLocalytics(eventName, parameters);
    }
}